/* 前台门户网站 路由 */ 
export default[
  {
    path: "/",
    name: "portalSite",
    component: () => import("@/views/portalSite/index")
  },
  {
    path: "/portalSite",
    name: "",
    component: () => import("@/views/portalSite/layout"),
    // redirect: "/portalSite/index",
    children:[
      // 联系我们
      {
        path: "contact",
        name: "portalSiteContact",
        component: () => import("@/views/portalSite/contact")
      },
      // 典型课程
      {
        path: "course",
        name: "portalSiteCourse",
        component: () => import("@/views/portalSite/course")
      },
      // 课程详情页
      {
        path: "courseDetail",
        name: "portalSiteCourseDetail",
        component: () => import("@/views/portalSite/components/couresDetail")
      },
      // 友情链接
      {
        path: "link",
        name: "portalSiteLink",
        component: () => import("@/views/portalSite/link")
      },
      // 通知公告
      {
        path: "notice",
        name: "portalSiteNotice",
        component: () => import("@/views/portalSite/notice")
      },
      // 新闻动态
      {
        path: "news",
        name: "portalSiteNews",
        component: () => import("@/views/portalSite/news")
      },
      // 通知公告 新闻动态 内容详情页
      {
        path: "pulicContent",
        name: "portalSiteShow",
        component: () => import("@/views/portalSite/noticeContent")
      },
      // 政策法规
      {
        path: "policy",
        name: "portalSitePolicy",
        component: () => import("@/views/portalSite/policy")
      },
      // 政策法规 详情
      {
        path: "policy/content",
        name: "portalSitePolicyContent",
        component: () => import("@/views/portalSite/policyContent")
      },
      // 培训项目
      {
        path: "project",
        name: "portalSiteProject",
        component: () => import("@/views/portalSite/project")
      },
      // 学员风采
      {
        path: "photoList",
        name: "portalSitePhotoList",
        component: () => import("@/views/portalSite/photoList")
      },
      // 操作指南
      {
        path: "guide",
        name: "portalSiteGuide",
        component: () => import("@/views/portalSite/guide")
      },
      // 常见问题
      {
        path: "question",
        name: "portalSiteQuestion",
        component: () => import("@/views/portalSite/question")
      },
    ]
  },
  {
    path: "/portalSite/courseContent",
    name: "portalSiteCourseContent",
    component: () => import("@/views/portalSite/courseContent")
  }
]



// WEBPACK FOOTER //
// ./src/router/portalSite.js